import { render, staticRenderFns } from "./CompletionDetails.vue?vue&type=template&id=776d09c5"
import script from "./CompletionDetails.vue?vue&type=script&lang=js"
export * from "./CompletionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports